import React from 'react';
import { Button } from '@chakra-ui/react';

class ButtonPress extends React.Component {
  state = {
    pressed: false,
  };    

  handleButtonPress = () => {
    this.setState({ pressed: true });
  }

  handleButtonRelease = () => {
    this.setState({ pressed: false });
  }

  render() {
    const { children } = this.props;
    const { pressed } = this.state;

    const buttonStyles = {
      boxShadow: pressed ? 'none' : '2px 2px 2px 1px #0F0F0F',
      transform: pressed ? 'translate(2px, 2px)' : 'none',
    };

    return (
      <Button
        onMouseDown={this.handleButtonPress}
        onMouseUp={this.handleButtonRelease}
        onMouseLeave={this.handleButtonRelease}
        style={buttonStyles}
        {...this.props}
      >
        {children}
      </Button>
    );
  }
}

export default ButtonPress;
